import TweetEmbed from "../../../../src/ui/blog/BlogTweetEmbed";
import * as React from 'react';
export default {
  TweetEmbed,
  React
};